export default __webpack_public_path__ + "static/media/Rocket.c16cf27f.png";